import { AVATAR_SIZES } from 'visitor-ui-component-library/avatar/constants/AvatarSizes';
import InitialMessageAvatars from './components/InitialMessageAvatars';
import styled from 'styled-components';
import { SMALL, MEDIUM } from 'visitor-ui-component-library/constants/sizes';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGArtificialIntelligenceEnhanced from 'visitor-ui-component-library-icons/icons/SVGArtificialIntelligenceEnhanced';
import { GREAT_WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { DEFAULT_PRIMARY_COLOR } from 'visitor-ui-component-library/theme/ColorConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const AIBotAvatarIconWrapper = styled.div.withConfig({
  displayName: "WelcomeMessageAvatars__AIBotAvatarIconWrapper",
  componentId: "e4naij-0"
})(["height:56px;width:56px;display:flex;justify-content:center;align-items:center;border:", ";border-radius:50%;background-color:", ";color:", ";box-sizing:border-box;"], ({
  theme,
  useDefaultColor
}) => `1px solid ${useDefaultColor ? DEFAULT_PRIMARY_COLOR : theme.colors.primary}`, GREAT_WHITE, ({
  theme,
  useDefaultColor
}) => useDefaultColor ? DEFAULT_PRIMARY_COLOR : theme.colors.primary);
const getAvatarHeightAboveBubble = isMobile => isMobile ? AVATAR_SIZES[SMALL] - 16 : AVATAR_SIZES[MEDIUM] - 16;
const IconWrapper = styled.div.withConfig({
  displayName: "WelcomeMessageAvatars__IconWrapper",
  componentId: "e4naij-1"
})(["display:inline-flex;vertical-align:middle;position:absolute;left:50%;top:", ";transform:translateX(-50%);"], ({
  isAIChatBot,
  mobile
}) => isAIChatBot ? '-40px' : `-${getAvatarHeightAboveBubble(mobile)}px`);
const WelcomeMessageAvatars = ({
  chatHeadingConfig,
  chatHeadingResponders,
  isAIChatBot,
  mobile,
  onClick,
  useDefaultColor
}) => {
  return /*#__PURE__*/_jsx(IconWrapper, {
    isAIChatBot: isAIChatBot,
    mobile: mobile,
    onClick: onClick,
    children: isAIChatBot ? /*#__PURE__*/_jsx(AIBotAvatarIconWrapper, {
      useDefaultColor: useDefaultColor,
      children: /*#__PURE__*/_jsx(VizExIcon, {
        icon: /*#__PURE__*/_jsx(SVGArtificialIntelligenceEnhanced, {
          width: "28px",
          height: "28px"
        })
      })
    }) : /*#__PURE__*/_jsx(InitialMessageAvatars, {
      chatHeadingConfig: chatHeadingConfig,
      chatHeadingResponders: chatHeadingResponders,
      mobile: mobile
    })
  });
};
WelcomeMessageAvatars.displayName = 'WelcomeMessageAvatar';
export default WelcomeMessageAvatars;